/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./drawerLogo.vue?vue&type=template&id=5f13b3a6"
import script from "./drawerLogo.vue?vue&type=script&lang=js"
export * from "./drawerLogo.vue?vue&type=script&lang=js"
import style0 from "./drawerLogo.vue?vue&type=style&index=0&id=5f13b3a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports